<template>
  <main @click="userInteraction">
    <TheHeader
      @sidenavToggle="displaySideNav = !displaySideNav"
      v-if="comingSoon === 'false'" />
    <TheSideNav
      :show="displaySideNav"
      @close="displaySideNav = false"
    />
    <div>
      <div id="app" class="body--mt">
        <router-view />
      </div>
      <a href="https://wa.link/9h53mc" target="_blank" rel="noreferrer">
        <div class="whatsapp-container">
            <img src="/static/svg/icons_fontawesome-whatsapp.svg" class="whatsapp-icon">
        </div>
      </a>
    </div>
    <FooterComponent v-if="comingSoon === 'false'"></FooterComponent>
    <CookiesMessage v-if="comingSoon === 'false'"></CookiesMessage>
  </main>
</template>

<script>
import TheHeader from '@/components/Navigation/TheHeader'
import TheSideNav from '@/components/Navigation/TheSideNav'
import FooterComponent from '@/partials/Footer'
import CookiesMessage from '@/partials/CookiesMessage'

import Vue from 'vue'
import Vuex from 'vuex'
import VModal from 'vue-js-modal'
import VueSweetalert2 from 'vue-sweetalert2'

import 'babel-polyfill'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { initSessionInterval } from '@/session/session'

Vue.use(Vuex)
Vue.use(VModal)
Vue.use(VueSweetalert2)

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    ignoreUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extensions:\/\//i
    ],
    release: process.env.SENTRY_RELEASE
  })
}

export default {
  name: 'App',
  metaInfo () {
    return {
      titleTemplate: '%s | Ekscelenko'
    }
  },
  components: {
    TheHeader,
    TheSideNav,
    FooterComponent,
    CookiesMessage
  },
  data () {
    return {
      displaySideNav: false,
      comingSoon: 'false'
    }
  },
  created () {
    if (this.$store.getters.sessionIsAlive) { initSessionInterval() }
  },
  methods: {
    userInteraction: function () {
      if (this.$store.getters.sessionIsAlive) { initSessionInterval() }
    }
  }
}
</script>

<style lang="scss">

[v-cloak] {
  display: none;
}

strong {
  font-weight: 700;
}

.-white {
  color: $white;
}

.-green {
  color: $green;
}

.-yellow {
  color: $yellow;
}

.-centered-info {
  text-align: center;
}

.-bottom-info {
  align-items: flex-end;
}

.-bg-gray {
  background: #eff2f5;
}

.-bg-green {
  background: $green;
}

.-bg-darkblue {
  background: $midnight-blue;
}

.-bg-yellow {
  background: $yellow;
}

.-img-responsive {
  max-width: 100%;
}

.-degradate {

  &:before {
    background-image: linear-gradient(104deg, #026d3e, #03337c 70%);
    content: "";
    height: 100%;
    left: 0;
    opacity: .67;
    position: absolute;
    top: 0;
    width: 100%;
  }
}

.error {
  margin-bottom: 1em;
  margin-top: -1em;
  color: $red;
  font-size: 12px;
}

.error-text {
  color: $red;
}

.select ~ .error {
  margin-top: -2em;
}

.box-errors {
  margin-top: 2rem;

  > p {
    text-align: center;
    font-size: 1em;
  }
}

.maintitle {
  font-size: 2.5em;
  font-weight: 100;
  position: relative;
  text-align: center;

  &.-align-left {
    text-align: left;
  }

  &.-align-right {
    text-align: right;
  }

  &.-xsmall {
    font-size: 1.8em;
  }

  &.-small {
    font-size: 2em;
  }

  &.-medium {
    font-size: 2.5em;
  }

  @media (min-width: 42rem) {
    font-size: 3.750em;

    &.-xsmall {
      font-size: 1.8em;
    }

    &.-small {
      font-size: 2.5em;
    }

    &.-medium {
      font-size: 3em;
    }
  }
}// maintitle

.-align-left {
  text-align: left;
}

.-align-right {
  text-align: right;
}

.secondarytitle {
  font-size: 2.4rem;
}

.-bold {
  font-weight: 700;
}

.-semi-bold {
  font-weight: 500;
}

@media (min-width: 42rem) {
  .-mob-only {
    display: none;
  }
}

.button {
  transition: background-color .3s ease, border .3s ease;
}

.button-fullwidth {
  width: 100%;
}

.slider {
  position: relative;
}

.slide {
  height: 0;
  opacity: 0;
  overflow: hidden;
  transition: opacity .5s ease, visibility .3s ease;
  visibility: hidden;

  &.active {
    opacity: 1;
    visibility: visible;
    height: auto;
  }
}

.counter-buttons {
  align-items: center;
  display: flex;
}

.counter {
  color: #8fa4b7;
  margin: -.8rem 1rem 0;

  .counter-actual,
  .counter-total {
    margin: 0 .5rem;
  }

  .counter-actual {
    color: $midnight-blue;
    font-weight: 500;
  }
}

.-gray-border{
  border: 1px solid #a4b3b7;
}

.no-margin {
  margin: 0;
}

.-vertical-align {
  align-items: center;
  justify-content: center;
}

.box-cumplo-pros {
  margin-top: 4rem;

  @media (min-width: 42rem) {
    margin-top: -8rem;
  }
}

.box-attributes {
  flex-direction: column;

  @media (min-width: 42rem) {
    flex-direction: row;
  }

  .box-attribute {
    padding: 2em;
    background-color: $midnight-blue;

    &:first-child {
      margin-bottom: 1em;
    }
  }

  @media (min-width: 42rem) {
    .box-attribute {
      margin-bottom: 0;

      &:first-child {
        margin-right: 1em;
        margin-bottom: 0;
      }
      &:last-child {
        margin-left: 1em;
      }
    }
  }
}

// Vue Transitions
// https://vuejs.org/v2/guide/transitions.html

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter,
  .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: all .3s ease;
}
.component-fade-enter, .component-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.-fullwidth {
  width: 100%;
}

.horizontal-responsive {
  width: auto;
  overflow-x: auto;
}

.-button-centered {
  display: block;
  margin: 0 auto;
}

.-padding-left {
  padding-left: 0!important;
}

.-padding-right {
  padding-right: 0!important;
}

.-padding-left-right {
  padding-left: 0!important;
  padding-right: 0!important;
}

.-margin-bottom-1 {
  margin-bottom: 1rem;
}

.-margin-top-1 {
  margin-top: 1rem;
}

.-margin-right-1 {
  margin-right: 10rem;
}

.-margin-left-2 {
  margin-left: 2rem;
}

@media (max-width: 42rem) {
  .-hidden-xs {
    display: none!important;
  }
}

.-inclinated {
  position: relative;
  padding: 6rem 0;
  color: $white;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(-221deg, #03738B 8%, #00CA6F 100%);
    transform: skewY(3deg);
  }
}

.-gradient {
  color: $white;
  background-image: linear-gradient(-221deg, #03738B 8%, #00CA6F 100%);
}

.table-component {
  display: flex;
  flex-direction: column;
  font-size: .8em;

  .table-component__filter {
    display: none;
  }
}

.table-component__filter {
  align-self: flex-end;
  position: relative;

  .table-component__filter__clear {
    position: absolute;
    top: 13%;
    right: 0;
    width: 1em;
    height: 1em;
    color: #007593;
    font-weight: bold;
    cursor: pointer;
  }
}

.table-component__table th,
.table-component__table td {
  padding: 1rem 1.4rem;
}

.table-component__table th {
  font-weight: bold;
}

.table-component__table tbody tr:nth-child(even) {
  background-color: #f2f6f7;
}

.table-component__th--sort,
.table-component__th--sort-asc,
.table-component__th--sort-desc {
  position: relative;
  cursor: pointer;  user-select: none;
}

.table-component__th--sort-asc:after,
.table-component__th--sort-desc:after {
  position: absolute;
  right: .25em;
  display: inline-block;
  color: #bbb;
}

.table-component__th--sort-asc:after {
  content: '↑';
}

.table-component__th--sort-desc:after {
  content: '↓';
}

.dashboard {
  margin-top: 100px;
  min-height: 400px;

  .preloader {
    margin: 7rem auto 5rem;
  }

  .box-table {
    margin-top: 2rem;
    padding: 2rem;
  }

  .box-no-investments {
    padding: 3rem 0;
    background: #efefef;

    @media (min-width: 42rem) {
      margin: 6rem 2rem;
      padding: 3rem;
      border: 1px solid #ccc;
      border-radius: 2rem;
    }

    .maintitle {
      margin-bottom: 3rem;
      font-size: 1.8em;
    }
  }
}

.modal-investment {

  .window-header {
    padding: 1rem 2rem;
    border-bottom: 1px solid $grey-100;
    overflow: hidden;
  }

  .title {
    float: left;
    margin: .5rem 0 0;
    max-width: 85%;
    font-weight: 300;
    font-size: 1.3em;
  }

  .button-close {
    $s: 3rem;
    $d: 1rem;

    float: right;
    padding: 0;
    margin: 0;
    width: $s;
    height: $s;
    line-height: $s;
    border-radius: 50%;
    background-color: $black;
    border: 0;
    font-size: 1.5em;
  }

  .modal-content {
    padding: 2rem 2rem 3rem;

    .detailtitle {
      margin-bottom: 1rem;
      font-weight: 300;
      font-size: 1.1em;

      @media (max-width: 42rem) {
        margin-top: 2rem;
        border-bottom: 1px solid #e3e3e3;
      }
    }
  }

  .box-detail-investment {

    p {
      margin-bottom: .5rem;
      font-size: .9em;
    }
  }

  .state {
    text-transform: capitalize;
  }
}

.-hidden {
  display: none;
}

.swal2-container .swal2-popup {
  font-size: 1em;

  .swal2-styled {
    padding: .5rem 2.5rem;
    height: auto;
  }
}

// TAB Component styling
.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
  border: 0;
  align-items: stretch;
  display: flex;
  justify-content: flex-start;
  margin-bottom: -20px;
  background-color: $white;
  border: solid 1px $grey;
  border-radius: 4px 4px 0 0;
  margin-right: .1rem;
  transform: translateY(2px);
  transition: transform .3s ease;
}

.tabs-component-tabs li {
  display: inline-block;

  &.is-active {
    color: $green;
    border-bottom: solid 1px $white;
    z-index: 2;
    transform: translateY(0);
  }

  &:before {
    content: '';
  }

  a {
    align-items: center;
    color: inherit;
    display: flex;
    padding: .75em 1em;
    text-decoration: none;

    &:hover {
      color: $green;
    }
  }
}

.field {
  position: relative;
  margin-bottom: 2rem;
}

.title {
  font-weight: 500;
}

.whatsapp-container {
    right: 30px;
    width: 60px;
    bottom: 30px;
    height: 60px;
    z-index: 999999;
    position: fixed;
    background: #25d366;
    border-radius: 100%;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    box-shadow: 0px 3px 5px -1px #00000033, 0px 6px 10px 0px #00000033, 0px 1px 18px 0px #0000001f;
}
.whatsapp-container:hover {
  background: #0fa045;
}
.whatsapp-icon {
    width: 40px;
    height: 40px;
    margin: 10px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue